export default "__VITE_ASSET__Dxp1T5JX__"